import React from 'react';
import ReviewQueue from './ReviewQueue';
/**
 * CZNA-1446 — the one place for everything waiting on the signed-in user: work returned to
 * them for correction and work they are to review, each row saying which. It replaced both
 * "Čeká na mě" under Autority and "Ke kontrole" in the rail; the whole review stays with the
 * administrator as "Všechny kontroly" (`/review-queue`).
 */
var Inbox = function (_a) {
    var match = _a.match;
    return React.createElement(ReviewQueue, { match: match, mode: "inbox" });
};
export default Inbox;
